import {
  currencyTypeRender,
  formatUSD,
  formatUSDNoDecimals,
  handleValidDate,
  handleValidTime,
  usdFormatter
} from '../../../../helpers/helpers';

import { calculationStatusForTable } from '../slice';
import { Link } from 'react-router-dom';

export const columns = [
  {
    id: 1,
    Header: 'Order ID',
    accessor: 'id',
    Cell: (cell: any) => {
      return cell?.row?.original?.order?.id;
    }
  },
  {
    id: 2,
    Header: 'User ID',
    accessor: 'user',
    Cell: (cell: any) => {
      return (
        <Link
          to={`/users/${cell?.row?.original?.user?.id}`}
          state={{ tab: '3' }}>
          {cell?.row?.original?.user?.id}
        </Link>
      );
    }
  },
  {
    id: 3,
    Header: 'User',
    accessor: 'user',
    Cell: (cell: any) => {
      return (
        <>
          {cell?.row?.original?.user?.firstName}{' '}
          {cell?.row?.original?.user?.lastName}
        </>
      );
    }
  },

  {
    id: 6,
    Header: 'Amount',
    accessor: 'price',
    Cell: (cell: any) => {
      return cell?.row?.original?.futuraBonus?.amount
        ? `${formatUSDNoDecimals(
            cell?.row?.original?.futuraBonus?.amount
          )} USDT`
        : '---';
    }
  },

  // {
  //   id: 7,
  //   Header: 'Payment address',
  //   accessor: 'paymentAddress',
  //   Cell: (cell: any) => {
  //     return cell?.value;
  //   }
  // },

  {
    id: 10,
    Header: 'Order Date',
    accessor: 'dateCreated',
    Cell: (cell: any) => (
      <>
        {handleValidDate(cell?.row?.original?.order?.orderDate)},
        <small className='text-muted'>
          {' '}
          {handleValidTime(cell?.row?.original?.order?.orderDate)}
        </small>
      </>
    )
  },

  {
    id: 11,
    Header: 'Payment Date',
    accessor: 'datePaid',
    Cell: (cell: any) => (
      <>
        {cell?.row?.original?.order ? (
          <>
            {handleValidDate(cell?.row?.original?.order?.datePaid)},
            <small className='text-muted'>
              {' '}
              {handleValidTime(cell?.row?.original?.order?.datePaid)}
            </small>
          </>
        ) : (
          '---'
        )}
      </>
    )
  },

  {
    id: 13,
    Header: 'Status',
    accessor: 'status',
    Cell: (cell: any) => {
      switch (cell?.row?.original?.order?.status) {
        case 1:
          return (
            <span className='badge text-uppercase badge-soft-warning'>
              PENDING
            </span>
          );

        case 2:
          return (
            <span className='badge text-uppercase badge-soft-success'>
              PAID
            </span>
          );

        case 3:
          return (
            <span className='badge text-uppercase badge-soft-danger'>
              CANCELED
            </span>
          );

        case 4:
          return (
            <span className='badge text-uppercase badge-soft-danger'>
              CANCELED BY USER
            </span>
          );
      }
    }
  }
];
